/**
 * Opciones de período de la vista ejecutiva.
 *
 * Se derivan del calendario real en el momento del render: antes eran tres literales fijos
 * (`2026-01`, `2025-12`, `2025-q4`) que además no llegaban a ninguna consulta.
 */

/** Id de la opción de histórico completo: no acota fechas, así que la API agrega lo acumulado. */
export const ALL_HISTORY_PERIOD = 'all';

export interface ExecutivePeriod {
  id: string;
  /** Etiqueta ya localizada; vacía para {@link ALL_HISTORY_PERIOD}, que se traduce con i18n. */
  label: string;
  /** 'YYYY-MM-DD'; `undefined` en la opción de histórico completo. */
  dateFrom?: string;
  dateTo?: string;
}

/** Cuántos meses cerrados se ofrecen además del mes en curso. */
const CLOSED_MONTHS_OFFERED = 5;

function toIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Histórico completo + el mes en curso + los {@link CLOSED_MONTHS_OFFERED} meses anteriores,
 * en el idioma de la UI.
 */
export function buildExecutivePeriods(today: Date, language: string): ExecutivePeriod[] {
  const periods: ExecutivePeriod[] = [{ id: ALL_HISTORY_PERIOD, label: '' }];

  for (let monthsBack = 0; monthsBack <= CLOSED_MONTHS_OFFERED; monthsBack += 1) {
    const firstDay = new Date(today.getFullYear(), today.getMonth() - monthsBack, 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() - monthsBack + 1, 0);
    periods.push({
      id: `${firstDay.getFullYear()}-${String(firstDay.getMonth() + 1).padStart(2, '0')}`,
      label: firstDay.toLocaleString(language, { month: 'long', year: 'numeric' }),
      dateFrom: toIsoDate(firstDay),
      dateTo: toIsoDate(lastDay),
    });
  }

  return periods;
}
